export enum FormEditorOperation {
  edit = 'Edit',
  new = 'New',
  delete = 'Delete',
}

export interface RowAttribute {
  key: string;
  subKey?: string;
  value: string | number;
  operation?: FormEditorOperation;
  data?: any;
}

export interface RowStatus {
  checked: Boolean;
  row: any;
}

export interface operationResponse {
  message: string;
  summary?: any;
  error?: any;
}
